import { CloudRain, CalendarCheck2 } from "lucide-react";
import { weatherLook } from "./palette";

const dayWords = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "short" });

export const RainCheck = ({ warnings, accent, moving, onMove }) => {
  if (!warnings?.length) return null;
  return (
    <div className="mt-5 rounded-2xl border border-sky-400/40 bg-sky-400/10 p-4" data-testid="rain-check">
      <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-200">
        <CloudRain className="h-3.5 w-3.5" /> Rain is coming for these
      </p>
      <div className="mt-2 space-y-2">
        {warnings.map((w) => {
          const look = weatherLook(w.code);
          const better = w.suggestion;
          return (
            <div key={w.event_id} className="flex flex-wrap items-center gap-2 text-xs text-sky-50/90"
                 data-testid={`rain-warning-${w.event_id}`}>
              <look.Icon className="h-3.5 w-3.5" style={{ color: look.tint }} />
              <span className="font-semibold">{w.title}</span>
              <span>
                on {dayWords(w.day)} in {w.place} — {look.blurb.toLowerCase()}, {w.precip}% chance of rain
              </span>
              {better ? (
                <>
                  <span className="inline-flex items-center gap-1 text-sky-200">
                    <CalendarCheck2 className="h-3 w-3" /> {dayWords(better.day)} looks drier ({better.precip}%)
                  </span>
                  <button
                    data-testid={`rain-move-${w.event_id}`}
                    onClick={() => onMove(w, better.day)}
                    disabled={moving === w.event_id}
                    className="ms-auto min-h-[30px] rounded-full px-3.5 text-xs font-semibold text-page active:scale-95"
                    style={{ backgroundColor: accent }}
                  >
                    {moving === w.event_id ? "Moving…" : "Move it there"}
                  </button>
                </>
              ) : (
                <span className="ms-auto text-sky-200/80">No drier day this week — bring a coat.</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
